export enum FilterType {
	BASE_RANKING_ID = 'ranking_ids',
	YEAR = 'year',
	SHOW_UNRANKED = 'show_unranked',
	LIMIT = 'limit',
	OFFSET = 'offset',
	COUNTRIES = 'country_iso_codes',
	COUNTRY_IDS = 'country_ids',
	REGIONS = 'rg',
	AREAS = 'ae',
	DISCIPLINE = 'di',
	DELIVERY_METHODS = 'mh',
	ORGANISATION = 'oi',
	REQUESTED_FILTERS = 'requested_filters',
	PRESELECTED_FILTER_TYPE = 'preselected_filter_type',
	PRESELECTED_FILTER_VALUES = 'preselected_filter_values'
}
